import { useEffect, useRef, useState } from "react";
import ClientInformation from "../ClientInformation";

const SkinCytology = () => {
  const [value, setValue] = useState();

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    adjustHeight();
  }, [value]);

  const adjustHeight = () => {
    if (textareaRef.current) {
      const element = textareaRef.current;
      const newHeight = element.scrollHeight;

      if (element.style.height !== `${newHeight}px`) {
        element.style.height = "auto";
        element.style.height = `${newHeight}px`;
      }
    }
  };

  return (
    <div>
      <ClientInformation />
      <p className="text-center font-bold inline-block border-b-2 border-gray-500 ">FINDINGS :</p>

      <div className="flex  gap-2 print:gap-1 w-full  print:-mb-2  mb-2">
        <textarea
          ref={textareaRef}
          className="w-full border p-4 text-sm resize-none print:hidden"
          value={value}
          autoFocus
          onInput={adjustHeight}
          onChange={(e) => setValue(e.target.value as any)}
          style={{ overflowY: "auto", scrollbarWidth: "thin", fontSize: "14px" }}
        />
        <div className="hidden print:block w-full print:border-none p-2 text-sm whitespace-pre-wrap">{value}</div>
      </div>

      <p className="font-bold mt-3 italic">This report is not valid for Vetero-Legal Purposes</p>
    </div>
  );
};
export default SkinCytology;
